<template>
  <div>
    <div class="vendor-form">
      <p class="vendor-form-label">
        {{ label }}<span class="text-ast" v-if="isRequired">*</span>
      </p>
      <div class="vendor-input" style="display:flex; flex:wrap">
        <div class="input-30">
          <input
            type="checkbox"
            value="1"
            v-model="location_1"
            :disabled="disabled"
          />
          <label class="ml20">Konsesi PKP2B Berau Coal</label>
        </div>
        <div class="input-30">
          <input
            type="checkbox"
            value="1"
            v-model="location_2"
            :disabled="disabled"
          />
          <label class="ml20">Kabupaten Berau</label>
        </div>
        <div class="input-30">
          <input
            type="checkbox"
            value="1"
            v-model="location_3"
            :disabled="disabled"
          />
          <label class="ml20">Indonesia</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'modelName',
    'label',
    'storeName',
    'mutationName',
    'isRequired',
    'disabled',
  ],
  computed: {
    location_1: {
      get: function() {
        return this.$store.state[this.storeName].location_1
      },
      set: function(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'location_1',
          value: newValue,
        })
      },
    },
    location_2: {
      get: function() {
        return this.$store.state[this.storeName].location_2
      },
      set: function(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'location_2',
          value: newValue,
        })
      },
    },
    location_3: {
      get: function() {
        return this.$store.state[this.storeName].location_3
      },
      set: function(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'location_3',
          value: newValue,
        })
      },
    },
  },
}
</script>
